import React from 'react';
import { Mail, Phone, MapPin, Heart } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-light">Engr. Aliyu Aziz Abubakar</h3>
            <p className="text-gray-400 leading-relaxed">
              Chartered Engineer & Digital Transformation Leader with 30+ years of excellence in engineering and technology innovation.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium">Contact Information</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center space-x-3">
                <Mail size={16} />
                <span>{personalInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} />
                <span>{personalInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} />
                <span>{personalInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Professional Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium">Professional Affiliations</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <div>Principal Partner - Integrated Engineering Associates</div>
              <div>Adviser - Africa Chamber of Digital Commerce</div>
              <div>Fellow - Nigerian Institution of Structural Engineers</div>
              <div>Ambassador - ID4Africa</div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <nav className="flex flex-wrap justify-center space-x-8 text-gray-400">
            {[
              { name: 'About', href: '#about' },
              { name: 'Experience', href: '#experience' },
              { name: 'Skills', href: '#skills' },
              { name: 'Projects', href: '#projects' },
              { name: 'Contact', href: '#contact' }
            ].map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  const element = document.querySelector(item.href);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="hover:text-white transition-colors duration-200 py-2"
              >
                {item.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between text-gray-400">
          <div className="flex items-center space-x-1 mb-4 md:mb-0">
            <span>© {currentYear} Engr. Aliyu Aziz Abubakar. Made with</span>
            <Heart size={16} className="text-red-500" />
            <span>for innovation.</span>
          </div>
          <button
            onClick={scrollToTop}
            className="text-gray-400 hover:text-white transition-colors duration-200"
          >
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;